import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Sidenav from "./components/sidebar/Sidenav";
import Firmware from "./pages/Firmware";
import UserManagement from "./pages/UserManagement";
import SiteDetails from "./pages/SiteDetails.js";
import ReleaseManagement from "./pages/ReleaseManagement";
import { getAPIErrorType } from "./api/axiosConfig";
import {
  onMsalLogOut,
  getMsalUserInfo,
  getMsalLogout,
  getMsalRefreshedToken,
} from "./authConfig";
import { getAPIUrl, getUserRole, checkUserAccessLevel } from "./components/common/helpers";
import axios from "axios";
import { getAuthToken } from "./api/api";
import { IdleTimer } from "./components/common/IdleTimeComponent";
import moment from "moment";
import Countdown from "react-countdown-now";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { InvalidAccess } from "./components/common/InvalidAccess";
import { Spinner } from "../src/components/common/Spinner";
import styled from "styled-components";
import FirmwareReport from "./pages/FirmwareReport.js";
import ContractManagement from "./pages/ContractManagement.js";
let timerReset;

const StyledModal = styled(Modal)`
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
  overflow: hidden !important;

  .modal-dialog {
    width: 100% !important;
    .modal-content {
      padding: 5px;
      height: 100% !important;
      width: 100% !important;
      border-radius: unset;
      top: 150px;
      .modal-header {
        padding: 15px 15px 1px 15px;
        color: black;
      }

      .modal-body {
        height: 100% !important;
        width: 100% !important;
        color: black;
        div {
          padding: 10px 0 0 0;

          button {
            border: 1px solid black;
            color: black;
            background-color: white;
            min-width: 100px;
            width: 25%;

            :hover {
              background-color: black;
              color: white;
            }
          }
        }
      }
    }
  }
`;

const Roles = {
  ADMIN: "GA",
  RELEASEMANAGER: "RM",
  FILEMANAGER: "FM",
  VIEWER: "Viewer",
}

const RouterComponents = [
  {path: "/usermanagement", component: UserManagement, requiredRole: [Roles.ADMIN]},
  {path: "/sitedetails", component: SiteDetails, requiredRole: [Roles.ADMIN, Roles.RELEASEMANAGER, Roles.VIEWER]},
  {path: "/releasemanagement", component: ReleaseManagement, requiredRole: [Roles.ADMIN, Roles.RELEASEMANAGER, Roles.VIEWER]},
  {path: "/firmwarereport", component: FirmwareReport, requiredRole: [Roles.ADMIN, Roles.RELEASEMANAGER, Roles.VIEWER]},
  {path: "/contractmanagement", component: ContractManagement, requiredRole: [Roles.ADMIN, Roles.RELEASEMANAGER, Roles.VIEWER]},
  {path: "/", component: Firmware},
];

const AuthorizedRoleBasedRoutes = ({ Component, disabledFeatures, role, requiredRole}) => {
  if (!requiredRole || 
    (Array.isArray(requiredRole) && requiredRole.includes(role))) {
      return <Component disabledFeatures={disabledFeatures}/>
    } else {
      return <InvalidAccess level="role" />
    }
	}

class App extends Component {
  constructor(props) {
    super(props);

    window.addEventListener("storage", (e) => onMsalLogOut());
    moment.locale(this.props.language);

    localStorage.setItem("Session Time", moment().unix());
    this.idleTimer = null;
    this.onIdle = this._onIdle?.bind(this);
    this.onAction = this._onAction?.bind(this);
    this.getTheConditionalRender = this.getTheConditionalRender?.bind(this);

    this.state = {
      showPopup: false,
      showProfile: false,
      userDetails: "LOADING",
      error: false,
    };
    window.setInterval(() => {
      getMsalRefreshedToken();
    },  3000000);

    const userInfo = getMsalUserInfo();
    const upn = userInfo?.username;
    const url = getAPIUrl("getUserDetailsByIdUrl") + upn?.toLowerCase();

    window.addEventListener("storage", (e) => onMsalLogOut());
    const AuthToken = getAuthToken();

    const getUserDetailsByID = () => {
      return axios.get(url, {
        headers:{ Authorization: AuthToken }
      })
    }

    const userDetailsFetch = async() => {
      try {
        const response = await getUserDetailsByID();
        if (response) {
          if (response?.data?.length) {
            this.setState({ userDetails: response?.data[0] });
          } else {
            this.setState({ userDetails: [] });
          }
        }
      } catch(error) {
        getAPIErrorType(error);
        this.setState({error: true});
        this.setState({ userDetails: [] });
      }
    }

    userDetailsFetch();
  }

  handlePopupToggle = () => {
    localStorage.setItem("Session Time", moment().unix());
    this.setState({ showPopup: false });
    clearTimeout(timerReset);
    getMsalRefreshedToken();
  };

  _onIdle(e) {
    if (moment().unix() - localStorage.getItem("Session Time") >= 2700 && 
    document.getElementsByClassName("blur-effect").length === 0) {
      this.setState({ showPopup: true });
      timerReset = setTimeout(getMsalLogout, 10000);
    } else {
      this.idleTimer.reset();
      clearTimeout(timerReset);
    }
  }

  _onAction(e) {
    localStorage.setItem("Session Time", moment().unix());
  }

  getTheConditionalRender() {
    const userInfo = getMsalUserInfo();
    const { role_id = 0 } = this.state.userDetails;
    const disabledFeatures = checkUserAccessLevel(role_id);
    if (role_id !== 0 && this.state.error === false) {
    return (
      <>
        <IdleTimer
        ref={(ref) => {
          this.idleTimer = ref;
        }}
        onIdle={this.onIdle}
        onAction={this.onAction}
        onActive={this.onActive}
        debounce={250}
        timeout={2700000}
      />
            <Sidenav userInfo={userInfo} role_id={role_id} />
            <main>
              <StyledModal
                show={this.state.showPopup}
                onHide={this.handlePopupToggle}
              >
                <ModalHeader closeButton>Session Timeout</ModalHeader>
                <hr />
                <ModalBody>
                  <Countdown
                    date={Date.now() + 10000}
                    renderer={({ seconds, completed }) =>
                      completed ? (
                        <span style={{ color: "red" }}>
                          For security purposes your session has timed-out.
                          Please go to the login page to log back in
                        </span>
                      ) : (
                        <React.Fragment>
                          <span>
                            You are being timed out due to session inactivity.
                            Please choose to stay signed in or to log off.
                            Otherwise you will be logged out automatically.
                          </span>
                          <div>
                            <button onClick={this.handlePopupToggle}>
                              Stay signed in
                            </button>
                            &nbsp;&nbsp;
                            <button onClick={getMsalLogout}>
                              Logoff({seconds})
                            </button>
                          </div>
                        </React.Fragment>
                      )
                    }
                  />
                </ModalBody>
              </StyledModal>
              <Routes>
                {RouterComponents.map(({path, component, exact, requiredRole}) => (
                  <Route key= {path} path = {path} exact={exact}
                  element  = {
                  <AuthorizedRoleBasedRoutes 
                  Component = {component}
                  disabledFeatures={disabledFeatures}
                  requiredRole= {requiredRole}
                  role={getUserRole(role_id)}>
                 </AuthorizedRoleBasedRoutes>}
                 >
                  </Route>
                ))}
              </Routes>
            </main>
          </>
    )
    } else {
      return (
      <InvalidAccess level= "user" error = {this.state.error}/>
      )
    }
  }

  render() {
    return (
      <div className="App">
        {this.state.userDetails === "LOADING" && this.state.error === false ? (
          <Spinner />
        ) : this.getTheConditionalRender()}
      </div>
    );
  }
}
export default App;
